import { use, useEffect } from "react";
import { useAtom } from "jotai";
import { AuthManagerContext, AuthStatus } from "../contexts/AuthManager";
import { pendingInvitationCode } from "../atoms/auth";
import { navigationRef } from "../navigations/navigationRef";
import { useSnackbar } from "../hooks/snackbar";
import { useClaimInvitationCode, useInvitationCodeErrorMessage } from "../hooks/invitation-code";

/**
 * Claims the code of an invitation link opened while signed out once a Lift user is signed in, and
 * opens its invitation: someone with an account signs in rather than up, and the signup is what
 * otherwise uses the code. A signup that used it has already forgotten it.
 */
const PendingInvitationClaimer = () => {
    const { status, user } = use(AuthManagerContext);
    const [code, setCode] = useAtom(pendingInvitationCode);
    const claimInvitationCode = useClaimInvitationCode();
    const errorMessageFor = useInvitationCodeErrorMessage();
    const { showSnackbar } = useSnackbar();

    useEffect(() => {
        if (status !== AuthStatus.In || !user || !code) {
            return;
        }
        // Forgotten first: it is claimed once, whatever the answer.
        setCode(null);
        void claimInvitationCode(code).then((result) => {
            if (!result.claimed) {
                showSnackbar({ text: errorMessageFor(result.messageKey), mode: "error" });
            } else if (navigationRef.isReady()) {
                navigationRef.navigate("Invitation", { invitationId: result.invitationId });
            }
        });
    }, [claimInvitationCode, code, errorMessageFor, setCode, showSnackbar, status, user]);

    return null;
};

export default PendingInvitationClaimer;
